<template>
  <div class="div-class">
    <p><b>404.</b><ins>{{ $t("404Vue.msgHead") }}</ins></p>
    <p>{{ $t("404Vue.msgDesc") }}
    </p>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
  .div-class{
    background-size:100% 100%;
    position: relative;
    width: 598px;
    height: 540px;
    background-color: #ffffff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
</style>
